module.exports = __webpack_public_path__ + "img/feature12.d0340e5.png";